(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["audelvyn-catalog"] && !Shopify.designMode) return;
  try {
    
function initAudelvynCatalog(){document.querySelectorAll('[data-av-catalog]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-av-filter]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-av-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-av-category]').forEach(card=>{card.hidden=button.dataset.avFilter!=='all'&&card.dataset.avCategory!==button.dataset.avFilter;});}));});}initAudelvynCatalog();document.addEventListener('shopify:section:load',initAudelvynCatalog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["audelvyn-collection"]) return;
  try {
    
function initAvFacets() {
  document.querySelectorAll('[data-av-facets]').forEach(function (form) {
    if (form.dataset.ready) { return; }
    form.dataset.ready = 'true';
    form.addEventListener('change', function () { if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); } });
    form.addEventListener('toggle', function (event) {
      if (!event.target.open) { return; }
      form.querySelectorAll('details[open]').forEach(function (other) { if (other !== event.target) { other.open = false; } });
    }, true);
    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) { form.querySelectorAll('details[open]').forEach(function (d) { d.open = false; }); }
    });
    form.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { form.querySelectorAll('details[open]').forEach(function (d) { d.open = false; }); }
    });
  });
}
initAvFacets();
document.addEventListener('shopify:section:load', initAvFacets);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["audelvyn-home"] && !Shopify.designMode) return;
  try {
    
function initAvSlides() {
  document.querySelectorAll('[data-av-slides]').forEach(function (track) {
    if (track.dataset.ready) { return; }
    track.dataset.ready = 'true';
    var wrap = track.closest('.av-hero-wrap');
    var dots = wrap ? wrap.querySelectorAll('[data-av-slide-to]') : [];
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setActive(index) {
      dots.forEach(function (dot, n) { dot.setAttribute('aria-current', n === index ? 'true' : 'false'); });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.getAttribute('data-av-slide-to'));
        track.scrollTo({ left: track.clientWidth * index, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    track.addEventListener('scroll', function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, { passive: true });
    setActive(0);
  });
}
initAvSlides();
document.addEventListener('shopify:section:load', initAvSlides);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
